import React, { useEffect, useState } from "react";
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { addTaskRequest, addTaskRequestStatus } from '../../../redux/task/task.action'
import { shiftListRequest } from '../../../redux/shift/shift.action'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { API_CONSTANTS, APP_CONSTANTS } from "../../../utils/AppConstants";
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import Modal from 'react-bootstrap/Modal';

const AddTask = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { addTaskSuccess, addTaskError, addTaskReqStatus } = useSelector(state => state.task)
    const { shiftListSuccess, shiftListError } = useSelector(state => state.shift)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const [selectedShift, setSelectedShift] = useState()
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [selectedTask, setSelectedTask] = useState()
    const TASK_TYPE = [
        { key: 'INDIVIDUAL', value: 'Individual' },
        { key: 'GROUP', value: 'Group' }
    ]
    const [showSuccessModal, setShowSuccessModal] = useState(false)

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.ADD_TASK, true)
            fetchBusinessList()
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.ADD_TASK) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.ADD_TASK, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (!isEmpty(shiftListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(shiftListError)) {
            setLoading(false)
        }
    }, [shiftListSuccess, shiftListError])

    useEffect(() => {
        if (addTaskReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            setShowSuccessModal(true)
        } else if (addTaskReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(addTaskError.message)
        }
        if (addTaskReqStatus.length) {
            dispatch(addTaskRequestStatus(''))
        }
    }, [addTaskSuccess, addTaskError, addTaskReqStatus])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedLocation)) {
            fetchShiftList()
        }
    }, [selectedLocation])

    useEffect(() => {
        if (isLoggedInUserEmployee(user) === true && !isEmpty(employeeSelectedBusiness) && !isEmpty(employeeSelectedLocation)) {
            fetchShiftList()
        }
    }, [employeeSelectedBusiness, employeeSelectedLocation])

    const fetchShiftList = () => {
        setLoading(true)
        let data = {}
        if (isLoggedInUserBusiness(user) && !isEmpty(selectedBusiness) && !isEmpty(selectedLocation)) {
            data.businessId = selectedBusiness.businessId
            data.locationId = selectedLocation.locationId
        }
        if (isLoggedInUserEmployee(user) && !isEmpty(employeeSelectedBusiness) && !isEmpty(employeeSelectedLocation)) {
            data.businessId = employeeSelectedBusiness
            data.locationId = employeeSelectedLocation
        }
        dispatch(shiftListRequest(data))
    }

    const handleSubmitClick = () => {
        if (isEmpty(name)) {
            displayErrorToast('Name cannot be blank')
        } else if (isNull(selectedTask)) {
            displayErrorToast('Task type not selected')
        } else if (isLoggedInUserBusiness(user) && isNull(selectedBusiness)) {
            displayErrorToast('Business not selected')
        } else if (isLoggedInUserBusiness(user) && isNull(selectedLocation)) {
            displayErrorToast('Business location not selected')
        } else {
            const data = {
                title: name,
                businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation,
                taskType: selectedTask.key,
                productCode: APP_CONSTANTS.PRODUCT_NAME,
                createdBy: isLoggedInUserBusiness(user) ? user.data.userDetails.userId : user.data.userDetails.employeeId,
                createdByUserType: user.data.userDetails.userType
            }
            if (!isEmpty(description)) {
                data.description = description
            }
            if (!isEmpty(selectedShift)) {
                data.shiftId = selectedShift.shiftId
            }
            setLoading(true)
            dispatch(addTaskRequest(data))
        }
    }

    const clearFields = () => {
        setName('')
        setDescription('')
        setSelectedShift(undefined)
        setSelectedTask(undefined)
    }

    const handleNewTaskAddClick = () => {
        setShowSuccessModal(false)
        clearFields()
    }

    const handleGoBack = () => {
        navigate(-1, { replace: true });
    };

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Add Task' />
                <CommonFormBorder>
                    <FormFieldLabel label='Enter details to add new task' />
                    <FormFieldLabel className='up-bold-label' label='Task Information' />
                    <CommonInputFloatFull id='name'
                        onChange={e => setName(e.target.value)}
                        placeholder='Task Name'
                        type='text'
                        value={name} />
                    <CommonInputFloatFull id='description'
                        onChange={e => setDescription(e.target.value)}
                        placeholder='Description'
                        type='text'
                        value={description}
                        rows={3}
                        multiline={true} />
                    <FormFieldLabel label='Select Task Type' />
                    {TASK_TYPE && <Select
                        className='select-full-width-no-border'
                        value={selectedTask}
                        getOptionLabel={e => e.value}
                        getOptionValue={e => e}
                        options={TASK_TYPE}
                        placeholder='Select Task Type'
                        onChange={e => setSelectedTask(e)} />}
                    {isLoggedInUserBusiness(user) && <div>
                        <FormFieldLabel className='up-bold-label' label='Business Information' />
                        <FormFieldLabel label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="content-error">{userBusinessListError.message}</div>}
                        <FormFieldLabel label='Select Business Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="content-error">{businessLocationListError.message}</div>}
                    </div>}
                    <FormFieldLabel label='Select Shift' />
                    {shiftListSuccess && shiftListSuccess.data && <Select
                        className='select-full-width-no-border'
                        value={selectedShift}
                        getOptionLabel={e => e.name}
                        getOptionValue={e => e}
                        options={shiftListSuccess.data}
                        placeholder='Select Shift'
                        onChange={e => setSelectedShift(e)} />}
                    {!shiftListSuccess && <div className="p-text">No shift found</div>}
                    <ButtonRow>
                        <CommonButton label='Submit'
                            onClick={() => { handleSubmitClick() }} />
                    </ButtonRow>
                </CommonFormBorder>
            </CommonScreenContent>
            <Modal
                onHide={() => {
                    setShowSuccessModal(false)
                }}
                show={showSuccessModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Success
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="at-success-modal-container">
                        <div className="at-success-img-container">
                            <img src={require('../../../assets/success_tick.png')} className="img" />
                        </div>
                        <div className="at-success-text">Task added successfully</div>
                        <div className="at-next-task-text">Do you want to add another task?</div>
                        <div className="at-modal-btn-container">
                            <div className="at-modal-no-btn" onClick={() => { handleGoBack() }}>NO</div>
                            <div className="at-modal-yes-btn" onClick={() => { handleNewTaskAddClick() }}>YES</div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default AddTask